import React,{useEffect, useMemo, useState} from 'react'
import { Link } from 'react-router-dom'
import LazyLoad from 'react-lazyload'
import Header from'../Component/Header'
import Footer from'../Component/Footer'
import { getCircular } from '../Service/Api'

const IMAGE_BASE = 'https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/'
const PUBLICATION_IMAGE_BASE = IMAGE_BASE + 'STPSFH/public/Images/'
const DEFAULT_SESSION = '2025-26'

// Hardcoded e-publications for the 2025-26 session
const hardcodedPublications = [
  { name: 'Class UKG', href: 'https://drive.google.com/file/d/1DjhCi7Faj4Fid6zsd5scno8J-zC_5Ebf/view', img: PUBLICATION_IMAGE_BASE + 'ukg-e-publication.jpg' },
  { name: 'Class LKG', href: 'https://drive.google.com/file/d/1ovMmZ54bEza6Np7dpMVuXjr16850oh4d/view', img: PUBLICATION_IMAGE_BASE + 'lkg-e-publication.jpg' },
  { name: 'Class Nursery', href: 'https://drive.google.com/file/d/1IRQXpec59JPH9y57h1xsOz2-L-Q2OCl4/view', img: PUBLICATION_IMAGE_BASE + 'nursery-e-publication.jpg' },
  { name: 'Class I', href: 'https://drive.google.com/file/d/1BkSsdLyv55rUTRl-t0huelwMU9_5Aq43/view', img: PUBLICATION_IMAGE_BASE + '1-e-publication.jpg' },
  { name: 'Class II', href: 'https://drive.google.com/file/d/1jNABCEpz1Z4cSX67I0ToKOjpMo8Lgd7s/view', img: PUBLICATION_IMAGE_BASE + '2-e-publication.jpg' },
  { name: 'Class III', href: 'https://drive.google.com/file/d/1dsA5RGG0hTdFVETVAOS1KHC1oBSTEz0a/view', img: PUBLICATION_IMAGE_BASE + '3-e-publication.jpg' },
  { name: 'Class IV', href: 'https://drive.google.com/file/d/18bpMv1suyO2ZEL8PgBrpCNsq2rcBrl5t/view', img: PUBLICATION_IMAGE_BASE + '4-e-publication.jpg' },
  { name: 'Class V', href: 'https://drive.google.com/file/d/1YxCUbaR6HiRJ8mDipXEwsnz36n3JZRyK/view', img: PUBLICATION_IMAGE_BASE + '5-e-publication.jpg' },
  { name: 'Class VI', href: 'https://drive.google.com/file/d/1sRSQ9tRLrx0k_3B-3K93Pc7g2AMCOD4S/view', img: PUBLICATION_IMAGE_BASE + '6-e-publication.jpg' },
  { name: 'Class VII', href: 'https://drive.google.com/file/d/1w7sz64Ig2LOJAl-Z53x_Hvfjpxyy9mPe/view', img: PUBLICATION_IMAGE_BASE + '7-e-publication.jpg' },
  { name: 'Class VIII', href: 'https://drive.google.com/file/d/16hK60SmKt9K74Zoa1heqA0b5n8gmQ0fi/view', img: PUBLICATION_IMAGE_BASE + '8-e-publication.jpg' },
  { name: 'Class IX', href: 'https://drive.google.com/file/d/1iS7IxK2uTFvYh3urvdac1p6wZQrlmn87/view', img: PUBLICATION_IMAGE_BASE + '9-e-publication.jpg' },
]

// Session starts in April: 2026-08 -> 2026-27, 2026-02 -> 2025-26
const sessionFromYearMonth = (year, monthIndex) => {
  const startYear = monthIndex >= 3 ? year : year - 1
  return `${startYear}-${String(startYear + 1).slice(-2)}`
}

const getSessionYear = (dateStr) => {
  const [year, month] = (dateStr || '').split('-').map(Number)
  if (!year || !month) return ''
  return sessionFromYearMonth(year, month - 1)
}

const getCurrentSession = () => {
  const now = new Date()
  return sessionFromYearMonth(now.getFullYear(), now.getMonth())
}

const EPublication = () => {

  const [apiPublications, setApiPublications] = useState([])
  const [selectedYear, setSelectedYear] = useState(DEFAULT_SESSION)

     useEffect(() => {
        document.title = 'E-Publication -  St Peters convent School Faridabad Haryana';
    }, []);

    useEffect(function(){
      async function publicationApi(){
        try {
            const circulars = await getCircular()
            const glimpses = (Array.isArray(circulars) ? circulars : []).filter((item) => item.category === 'ePublication')
            setApiPublications(glimpses)
        } catch (error) {
          console.error(error)
        }
      }
      publicationApi()
    },[])

    const sessionYears = useMemo(() => {
      const years = new Set([DEFAULT_SESSION, ...apiPublications.map((item) => getSessionYear(item.date))])
      return Array.from(years).filter(Boolean).sort((a, b) => b.localeCompare(a))
    }, [apiPublications])

    // Default to the current session if it has data, otherwise the most recent one
    useEffect(() => {
      const current = getCurrentSession()
      setSelectedYear(sessionYears.includes(current) ? current : sessionYears[0])
    }, [sessionYears])

    const publications = selectedYear === DEFAULT_SESSION
      ? hardcodedPublications
      : apiPublications
          .filter((item) => getSessionYear(item.date) === selectedYear)
          .map((item) => ({
            name: item.title,
            href: item.url?.length > 0 ? item.url : IMAGE_BASE + item.attachments?.[0],
            img: item.images?.[0] ? IMAGE_BASE + item.images[0] : PUBLICATION_IMAGE_BASE + 'dummy.jpg',
          }))

  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li>
     <li> E-Publication</li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>E-Publication  </h1>
         </div>
     </div>
     <div className="row">
     <div className="col-lg-12">
     <div className="chooseyear">
     <select id="chooseddlYear"
         value={selectedYear}
         onChange={(e) => setSelectedYear(e.target.value)}
         className="yearSelection"
     >
         {sessionYears.map((yr) => (
             <option key={yr} value={yr}>{yr}</option>
         ))}
     </select>

 </div>
   </div>
 </div>
     <div className="row">
     {publications.map((item, index) => (
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch" key={`${item.href}-${index}`}>
     <div className="video-gallery">
        <a href={item.href} target="_blank" rel="noopener noreferrer">
                 <LazyLoad> <img src={item.img} alt={item.name} className="img-fluid" />  </LazyLoad>
                 <div>
                 <h3>{item.name}</h3>
                 </div>
         </a>
       </div>
     </div>
     ))}

     {/* <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
        <Link to="https://drive.google.com/file/d/1sRSQ9tRLrx0k_3B-3K93Pc7g2AMCOD4S/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication1.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div>
                 <h3>Class X </h3>
                 </div>
         </Link>
       </div>
     </div>  */}

{/*
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
        <Link to="https://drive.google.com/file/d/1LB69mA2Ba0iojdsZUGU5p6BJPaQJCqxz/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication1.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div>
                 <h3>Class III </h3>
                 </div>
         </Link>
       </div>
     </div>
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
        <Link to="https://drive.google.com/file/d/1ECqiZvScSgyhTvUZNvGBmJLu4wjah25Y/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication2.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div>
                 <h3> Class IV </h3>
                 </div>
         </Link>
       </div>
     </div>
       <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
        <Link to="https://drive.google.com/file/d/1ZRuWzsF_E4rkhG5YOUgK-F_zO27_kz3z/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication5.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div>
                 <h3> Class V </h3>
                 </div>
         </Link>
       </div>
     </div>
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
        <Link to="https://drive.google.com/file/d/1I8gOqV3_ABjC1P9lcN1fnIo8Fo0kskmr/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication6.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div>
                 <h3> Class VI </h3>
                 </div>
         </Link>
       </div>
     </div>
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
        <Link to="https://drive.google.com/file/d/1UGdKSBsiHIxjd748AGA7br3gjF5n7Kaw/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication7.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div>
                 <h3>  Class VII</h3>
                 </div>
         </Link>
       </div>
     </div>
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
        <Link to="https://drive.google.com/file/d/1-hkcjwHXMzG_bI_zo_NuGme4vwrUVSFn/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication3.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div>
                 <h3> Class VIII</h3>
                 </div>
         </Link>
       </div>
     </div>
     <div className="col-xl-3 col-lg-4 col-md-6 col-sm-12 videosearch">
     <div className="video-gallery">
        <Link to="https://drive.google.com/file/d/1PxxLz7RJ1JoqkhZmu_8npNpOZEvwB-iP/view" target="_blank">
                 <LazyLoad> <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/EPublication4.jpg" alt="Gallery Placeholder" className="img-fluid" />  </LazyLoad>
                 <div>
                 <h3> Class IX </h3>
                 </div>
         </Link>
       </div>
     </div>  */}


     </div>
  </div>
</div>
<Footer/>
    </>
  )
}

export default EPublication
